
/**
 * 마지막 메시지 역할
 * @nullable
 */
export type GetConversation200AllOfLastMessageRole = typeof GetConversation200AllOfLastMessageRole[keyof typeof GetConversation200AllOfLastMessageRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetConversation200AllOfLastMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
